"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSimplifyTabs = void 0;

var _ActionTypes = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ActionTypes"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var updateSimplifyTabs = function updateSimplifyTabs(payload) {
  // Temporarily using modalInteraction. Will remove when WP006 is over.
  (0, _getUsageTracker.default)().track('modalInteraction', {
    action: (payload ? 'hide' : 'show') + " all plans",
    modalName: ''
  });
  return {
    type: _ActionTypes.default.WP006_SIMPLIFY_TABS_REQUESTED,
    payload: payload
  };
};

exports.updateSimplifyTabs = updateSimplifyTabs;


//////////////////
// WEBPACK FOOTER
// ./js/actions/Wp006SimplifyTabsActions.js
// module id = 605
// module chunks = 5 6